// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__3tGQ7","info":"UpdateTermsInfo_info__vBjsa"};